import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { Language } from "../Language";
import translationEN from "./en.json";
import translationFR from "./fr.json";
import translationDE from "./de.json";
import translationES from "./es.json";
import translationAR from "./ar.json";

const resources = {
    en: {
        translation: translationEN,
    },
    fr: {
        translation: translationFR,
    },
    de: {
        translation: translationDE,
    },
    es: {
        translation: translationES,
    },
    ar: {
        translation: translationAR,
    },
};

// Declares the displayed language and its reading direction on <html>, read by screen readers and inherited by
// the content rendered outside the app root: notifications, dialogs and modals (RGAA 8.3, 8.10).
// Registered before init, which emits the event for the detected or cached language.
function applyDocumentLanguage(language: string) {
    const documentLanguage = i18n.resolvedLanguage ?? language;
    document.documentElement.setAttribute("lang", documentLanguage);
    document.documentElement.setAttribute("dir", i18n.dir(documentLanguage));
}

i18n.on("languageChanged", applyDocumentLanguage);

i18n.use(initReactI18next)
    .use(LanguageDetector)
    .init({
        returnNull: false,
        fallbackLng: Language.FR,
        supportedLngs: ["en", "fr", "de", "es", "ar"],
        resources,
    });

export default i18n;
